exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ech_box[data-v-4506e9a3]{background:#fff;padding:24px 50px}.ech_box .echarts[data-v-4506e9a3]{width:100%;height:500px}", ""]);

// exports
